/* eslint-disable import/first, import/newline-after-import */

import 'global/site_header/main_logo_component/main_logo_component.css';
import 'global/site_header/site_header_component/site_header_component.css';
import 'global/site_header/explore_nav/explore_nav_component/explore_nav_component';
import 'global/site_header/main_nav_component/main_nav_component.css';
import 'global/site_header/join_pro_link_component/join_pro_link_component.css';
import 'global/site_header/user_menu/user_menu_component/user_menu_component.css';
import 'global/site_header/user_menu/free_trial_menu_badge_component/free_trial_menu_badge_component';

import 'global/site_header/auth_menu_group_component/auth_menu_group_component.css';
import 'global/site_header/mobile_menu_component/mobile_menu_component.css';
import 'global/site_header/mobile_auth_menu_component/mobile_auth_menu_component.css';
import 'global/site_header/mobile_search.css';

import 'components/util/logos/logos';
import 'global/site_header/notifications_menu_component/notifications_menu_component.css';

import 'components/search/search-form/search-form';
import 'components/util/inline-filters/inline-filters';

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import { featureEnabled, splitTestEnabled } from 'lib/helpers'; // eslint-disable-line import/order

import SiteHeaderController from 'global/site_header/site_header_component/site-header-component-controller';
EezyStimulusApplication.register('site-header', SiteHeaderController);

/* start: split-test marketing_notifications_v1 */
if (featureEnabled('marketing_notifications_v1') || splitTestEnabled('marketing_notifications_v1')) {
  import(
    /* webpackChunkName: "notifications-menu-controller" */
    /* webpackPreload: true */
    'global/site_header/notifications_menu_component/notifications-menu-controller'
  ).then((controller) => {
    EezyStimulusApplication.register('notifications-menu', controller.default);
  });
}
/* end: split-test marketing_notifications_v1 */

import(
  /* webpackChunkName: "explore-nav-controller" */
  /* webpackPreload: true */
  'global/site_header/explore_nav/explore_nav_component/explore-nav-controller'
).then((controller) => {
  EezyStimulusApplication.register('explore-nav', controller.default);
});
